import { FormGroup, FormLabel, FormSelect } from "react-bootstrap";
import styled from "styled-components";

const StyledLabel = styled(FormLabel)`
    font-size: 15px;
    line-height: 25px;
    margin: 0;
    margin-bottom: 0;
`;

const StyledFormSelect = styled(FormSelect)`
    border: 1px solid #787878;
    height: 48px;
    box-sizing: border-box;
    &:focus {
        border-color: #9654ff;
        box-shadow: none;
    }
    &:hover {
        border-color: #9654ff;
        box-shadow: none;
    }
    &.form-select::before {
        background-color: red;
    }
    & option {
        background-color: #f0f2f2;
        border-color: #8a0538;
        box-sizing: border-box;
        padding-top: 10px;
        margin: 10px;
    }
    &.bootstrap-select.btn-group .dropdown-menu.open {
        background-color: red !important;
    }
    &.selectpicker {
        &.dropdown-menu {
            background-color: red;
        }
    }
`;

const StyledFormGroup = styled(FormGroup)`
    position: relative;
    > input {
        border: 0;
        border-bottom: 2px solid lightgrey;
        outline: none;
        min-width: 180px;
        font-size: 16px;
        border-radius: 0;
    }
    > label {
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;
        margin-left: 13px;
        z-index: 10;
    }
`;

const StyledLabelFloating = styled(FormLabel)`
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #787878;
    margin: 0;
    margin-bottom: 0;
`;

export default {
    StyledLabel,
    StyledFormSelect,
    StyledFormGroup,
    StyledLabelFloating,
};
